export const parentModeConstants = {
    SET_IS_PARENT_MODE: "SET_IS_PARENT_MODE",
    SET_PARENT_MODE_FAMILY_ID: "SET_PARENT_MODE_FAMILY_ID",
}
